import styled from "styled-components";

export const HeaderStyle = styled.header`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-around;
    height: 80px;
    width: 100%;

    a{
        cursor: pointer;
        background: #343B41;
        border: none;
        color: #ffffff;
        text-decoration: none;
        border-radius: 4px;
        padding: 8px 14px;
    }
`